var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import Switch from "antd/es/switch";
import "antd/es/switch/style/index.js";
import { observer } from 'mobx-react';
import { runtime } from '../../../../../classes/runtime/Runtime';
let MenubarHearAvailablePopover = class MenubarHearAvailablePopover extends React.PureComponent {
    render() {
        const { app } = this.props;
        const { menubarHear } = app.menubar;
        return (React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                minWidth: 400,
                paddingLeft: 15
            }, onMouseEnter: action(() => (menubarHear.isHearPopoverHovering = true)), onMouseLeave: action(() => (menubarHear.isHearPopoverHovering = false)) },
            React.createElement("h4", null, "Diese Frage kann auch mit Spracheingabe beantwortet werden"),
            !runtime.solidBrowserRuntime.browserConfig.isMicrophoneActivatedByUser && (React.createElement("div", { style: { marginBottom: 10 } }, "Schlie\u00DFe ein Mikrofon an und aktiviere die Spracheingabe:")),
            React.createElement(Switch, { checked: runtime.solidBrowserRuntime.browserConfig.isMicrophoneActivatedByUser, checkedChildren: "Spracheingabe ausschalten", unCheckedChildren: "Spracheingabe aktivieren", onChange: action((b) => (runtime.solidBrowserRuntime.browserConfig.isMicrophoneActivatedByUser = b)) })));
    }
};
MenubarHearAvailablePopover = __decorate([
    observer
], MenubarHearAvailablePopover);
export { MenubarHearAvailablePopover };
